import { sanitizeHtml } from '@/utils/sanitize';

interface PersonaHtmlContentProps {
  html: string | null | undefined;
}

// Контент персоны хранится как готовый HTML (не markdown), в отличие от остальных
// артефактов — рендерим его напрямую через dangerouslySetInnerHTML с санитизацией.
export function PersonaHtmlContent({ html }: PersonaHtmlContentProps) {
  return (
    <div className="max-w-none">
      <div
        className="persona-content"
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(
            (html || '')
              .replace(/```html\n?/gi, '')
              .replace(/```\n?/g, '')
              .replace(/^```$/gm, '')
              .trim()
          ),
        }}
      />

      <style>{`
        .persona-content h3 {
          font-family: 'Manrope', sans-serif;
          font-weight: 600;
          font-size: 20px;
          line-height: 28px;
          color: #0d0d0d;
          margin-bottom: 16px;
          margin-top: 32px;
        }
        .persona-content h3:first-child {
          margin-top: 0;
        }
        .persona-content p {
          font-family: 'Segoe UI', sans-serif;
          font-size: 16px;
          line-height: 24px;
          color: #0d0d0d;
          margin-bottom: 16px;
        }
        .persona-content ul {
          list-style-type: disc;
          padding-left: 24px;
          margin-bottom: 24px;
          font-family: 'Segoe UI', sans-serif;
          font-size: 16px;
          line-height: 24px;
          color: #0d0d0d;
        }
        .persona-content li {
          margin-bottom: 8px;
        }
        .persona-content blockquote {
          border-left: 4px solid #2197f1;
          padding-left: 16px;
          padding-top: 8px;
          padding-bottom: 8px;
          margin: 16px 0;
          font-style: italic;
          font-family: 'Segoe UI', sans-serif;
          font-size: 16px;
          line-height: 24px;
          color: #565858;
        }
        .persona-content strong {
          font-weight: 600;
        }
      `}</style>
    </div>
  );
}
